import pluralize from "pluralize";

function getReceivedDate(date) {
  const parts = date.toDateString().split(" ");
  return parts[1] + " " + parts[2];
}

function getReceivedTime(date) {
  const timeArr = date.toLocaleTimeString().split(":");
  timeArr.pop();
  return timeArr.join(":");
}

/**
 * Format time offset between from date and to date as received time. E.g A few seconds ago, 10 minutes ago, ...
 */
export default (fromDate, toDate) => {
  fromDate = new Date(fromDate);
  toDate = new Date(toDate);

  const diff = toDate - fromDate;

  const ONE_SECOND = 1000;
  const TEN_SECONDS = 10 * ONE_SECOND;
  const ONE_MINUTE = 60 * ONE_SECOND;
  const ONE_HOUR = 60 * ONE_MINUTE;
  const ONE_DAY = 24 * ONE_HOUR;

  if (diff < TEN_SECONDS) {
    return "A few seconds ago";
  } else if (diff < ONE_MINUTE) {
    const sec = Math.floor(diff / ONE_SECOND);
    return sec + " seconds ago";
  } else if (diff < ONE_HOUR) {
    const min = Math.floor(diff / ONE_MINUTE);
    return `${min} ${pluralize("minute", min)} ago`;
  } else if (diff < ONE_DAY) {
    const hours = Math.floor(diff / ONE_HOUR);
    return `${hours} ${pluralize("hour", hours)} ago`;
  } else {
    const days = Math.floor(diff / ONE_DAY);

    const date = getReceivedDate(fromDate);
    const time = getReceivedTime(fromDate);

    if (days === 1) {
      return "Yesterday at " + time;
    } else {
      return date + " at " + time;
    }
  }
};
